var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"base__text",class:{
        'is-line-clamp': _setup.props.lineClamp,
        'is-ellipsis': _setup.props.isEllipsis,
        'is-underline': _setup.props.isUnderline,
        'is-strikethrough': _setup.props.isStrikethrough,
        'is-anywhere-wrap': _setup.props.isAnywhereWrap,
        [_setup.props.customClass]: !!_setup.props.customClass,
    },style:({
        'max-width': _setup.props.maxWidth,
        'min-width': _setup.props.minWidth,
        '-webkit-line-clamp': _setup.props.lineClamp,
    })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }